import styled from 'styled-components';

import { media } from '../../styles/media';

export const Root = styled.div`
  background-image: url(${props => props.background});
  backround-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  color: white;
  padding: 4rem 0;
  position: relative;

  &:before {
    background-color: ${props => props.theme.color.secondary};
    content: '';
    position: absolute;
    opacity: 0.9;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
  }

  ${media.tablet`
    padding: 6.5rem 0 5.5rem;
  `};
`;

export const Wrapper = styled.div`
  ${media.tablet`
    margin: 0 auto;
    max-width: 790px;
  `};
`;

export const InformationWrapper = styled.div`
  text-align: center;

  ${media.tablet`
    text-align: left;
  `};
`;

export const Title = styled.h2`
  color: white;
  font-family: ${props => props.theme.font.bold};
  font-size: 2.6rem;
  margin-bottom: 2rem;
  text-transform: uppercase;

  i {
    position: relative;
    top: 2px;
  }

  ${media.tablet`
    font-size: 2.8rem;
  `};
`;

export const Tips = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;

  ${media.tablet`
    flex-direction: row;
  `};
`;

export const Tip = styled.span`
  background-color: white;
  border-radius: 2.2rem;
  color: ${props => props.theme.color.darkGrey};
  display: inline-block;
  font-family: ${props => props.theme.font.bold};
  font-size: 1.6rem;
  line-height: 1.8rem;
  margin-bottom: 2rem;
  text-transform: uppercase;
  padding: 1.2rem 2.5rem;

  ${media.tablet`
    font-size: 1rem;
    line-height: 1.2rem;
    margin-right: 1.5rem;
    padding: 1rem 2rem;
  `};
`;

export const Body = styled.div`
  color: white;
  font-size: 2rem;
  line-height: 2.4rem;
  padding: 0 4.5rem;

  ${media.tablet`
    padding: 0;
  `};
`;

export const Links = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;

  ${media.tablet`
    flex-direction: row;
  `};
`;

export const Link = styled.a`
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 2.2rem;
  color: white;
  font-size: 1.8rem;
  display: inline-block;
  margin-top: 2rem;
  text-decoration: none;
  padding: 1rem 2rem;
  transition: border 300ms;

  ${media.tablet`
    font-size: 1.4rem;
    margin-right: 1.5rem;
    padding: 0.75rem 2rem;
  `};

  &:hover {
    border: 1px solid rgba(255, 255, 255, 1);
  }
`;
